interface SvgCheckmarkProps {
  className?: string;
  width?: number | string;
  height?: number | string;
}
export default function SvgCheckmark(props: SvgCheckmarkProps) {
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}><path d="M9.75 18L3 11.25L4.0605 10.1895L9.75 15.8783L19.9395 5.68951L21 6.75001L9.75 18Z" fill="currentColor" /></svg>;
}